export default __webpack_public_path__ + "static/media/img-0726-estonia-premium-face.4e4570dc.png";